import type { Paginated } from '@/api/types'

export function getNextPageParam<T>(
  lastPage: Paginated<T>,
  allPages: Paginated<T>[],
  limit: number
): number | undefined {
  const requestedCount = allPages.length * limit
  const hasMore =
    lastPage.content.length > 0 && requestedCount < lastPage.totalRegisters
  return hasMore ? allPages.length : undefined
}
